function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_37303_34888)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.8008 35.2971C51.7439 35.3296 22.4804 18.4358 22.4804 18.4358L29.7821 14.2124H0.567275V31.0737L7.7796 26.769L37.1406 43.7602L51.8008 35.2971Z",
  fill: "white",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_37303_34888)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.296 98.7391L19.2725 93.8335C17.9567 93.0213 17.1364 91.2507 17.1445 88.7572L17.2582 51.4367C17.2744 46.6447 20.3202 41.0162 24.0644 38.8557L89.2028 1.2509C90.7784 0.341237 92.2242 0.195042 93.3612 0.682361L102.385 5.59616",
  fill: "#F4F4F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.296 98.7391L19.2725 93.8335C17.9567 93.0213 17.1364 91.2507 17.1445 88.7572L17.2582 51.4367C17.2744 46.6447 20.3202 41.0162 24.0644 38.8557L89.2028 1.2509C90.7784 0.341237 92.2242 0.195042 93.3612 0.682361L102.385 5.59616",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9158 56.1636L25.8021 93.4841C25.7858 98.2518 28.7991 100.372 32.5352 98.2193L97.5355 60.6957C101.272 58.5434 104.317 52.9229 104.35 48.1391L104.593 10.7454C104.626 5.94535 101.613 3.80927 97.8766 5.96972L32.722 43.5826C28.9778 45.7431 25.932 51.3798 25.9158 56.1636Z",
  fill: "white",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.399 40.0094L101.735 39.2703C100.785 39.0104 100.224 37.9708 100.232 36.5007L100.289 27.2742C100.297 25.8041 100.882 24.0985 101.841 22.734L104.537 18.9004L104.399 40.0094Z",
  fill: "#1A1A1A",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.2898 82.7866C33.2736 86.8963 35.897 88.74 39.1133 86.8882L33.2898 82.7866Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.2898 82.7866C33.2736 86.8963 35.897 88.74 39.1133 86.8882",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.2598 47.3755C36.0353 49.2354 33.3876 54.133 33.3713 58.259L39.2598 47.3755Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.2598 47.3755C36.0353 49.2354 33.3876 54.133 33.3713 58.259",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.7694 24.5443C91.7937 20.4183 89.1784 18.5584 85.954 20.4183L91.7694 24.5443Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.7694 24.5443C91.7937 20.4183 89.1784 18.5584 85.954 20.4183",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.7265 59.9732C88.9428 58.1132 91.5987 53.2238 91.623 49.106L85.7265 59.9732Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.7265 59.9732C88.9428 58.1132 91.5987 53.2238 91.623 49.106",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.5351 43.8828L71.4316 55.3429",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.5995 44.208L64.4961 55.6681",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.5491 52.8179L65.4375 64.278",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.1152 51.2095L61.0117 62.6696",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.58 56.269L59.4766 67.721",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.3461 39.3589L71.2773 62.5634",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.317 12.922L89.3162 7.72394C90.1771 7.2285 90.2015 6.42442 89.3731 5.94522C88.5365 5.46602 87.1476 5.47415 86.2786 5.97771L77.2469 11.192C76.3779 11.6956 76.3698 12.4915 77.2144 12.9626C78.0591 13.4337 79.4561 13.4175 80.317 12.922Z",
  fill: "#1A1A1A",
  stroke: "#1A1A1A",
  strokeWidth: 0.812199,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("rect", {
  width: 19.4928,
  height: 19.4928,
  rx: 9.74639,
  transform: "matrix(-1 0 0 1 104.188 79.5952)",
  fill: "#007BFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.2272 93.8418V92.4123L95.0738 88.6047C95.221 88.4661 95.338 88.3318 95.4246 88.2019C95.5113 88.0633 95.5762 87.9247 95.6196 87.786C95.6629 87.6474 95.6845 87.5088 95.6845 87.3702C95.6845 87.0756 95.5546 86.8331 95.2947 86.6425C95.0434 86.4432 94.7272 86.3436 94.346 86.3436C93.9388 86.3436 93.5576 86.4302 93.2024 86.6035C92.8472 86.7681 92.4617 87.054 92.0459 87.4612L90.9283 86.0967C91.4481 85.6029 91.9982 85.2303 92.5787 84.9791C93.1678 84.7278 93.7786 84.6022 94.411 84.6022C95.0608 84.6022 95.6239 84.7148 96.1004 84.9401C96.5855 85.1567 96.9624 85.4642 97.231 85.8628C97.4995 86.2526 97.6338 86.7118 97.6338 87.2402C97.6338 87.5261 97.5905 87.8034 97.5039 88.0719C97.4259 88.3318 97.3003 88.5874 97.127 88.8387C96.9537 89.0899 96.7285 89.3498 96.4512 89.6184L93.8262 92.1524L97.7638 92.1394V93.8418H91.2272Z",
  fill: "white"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_37303_34888"
}, /*#__PURE__*/React.createElement("rect", {
  width: 52.0457,
  height: 30.36,
  fill: "white",
  transform: "matrix(-1 0 0 1 52.207 13.8071)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_37303_34888"
}, /*#__PURE__*/React.createElement("rect", {
  width: 88.2698,
  height: 99.47,
  fill: "white",
  transform: "matrix(-1 0 0 1 105 0)"
})));
function SvgInstrSecondCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 100,
    viewBox: "0 0 105 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrSecondCapture);
export default __webpack_public_path__ + "static/media/instr-second-capture.375d448301a77777e3b2b56fa3431d25.svg";
export { ForwardRef as ReactComponent };